import { CSSProperties, useContext, useMemo, useState } from "react";
import { DataContext } from "../../lib/contexts";
import { Menu, MenuItem } from "@mui/material";

interface SelectPlaceButtonProps {
  style?: CSSProperties;
}

export function SelectPlaceButton(props: SelectPlaceButtonProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    categoryOrders,
    selectedCategoryOrderId,
    updateSelectedCategoryOrderId,
  } = useContext(DataContext);

  const selectedCategoryOrderName = useMemo(
    () =>
      categoryOrders.find((co) => co._id === selectedCategoryOrderId)?.name ||
      "",
    [selectedCategoryOrderId, categoryOrders],
  );

  return (
    <div style={{ flexShrink: 0, ...props.style }}>
      <button
        id="place-selector-button"
        aria-controls={open ? "place-selector-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{
          height: 40,
          maxWidth: 132,
          padding: "0 12px",
          border: "none",
          borderRadius: 14,
          background: open ? "#e8f1fd" : "#f5f5f5",
          color: open ? "#2563eb" : "#4b5563",
          display: "flex",
          alignItems: "center",
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer",
          WebkitTapHighlightColor: "transparent",
        }}
        onClick={handleClick}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {selectedCategoryOrderName}
        </span>
      </button>
      <Menu
        id="place-selector-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          list: {
            "aria-labelledby": "place-selector-button",
            sx: { padding: "4px" },
          },
          paper: {
            sx: {
              marginTop: "8px",
              width: "max-content",
              minWidth: anchorEl?.offsetWidth,
              maxWidth: "calc(100vw - 24px)",
              borderRadius: "14px",
              border: "1px solid #e5e7eb",
              boxShadow: "0 12px 32px rgba(55, 65, 81, 0.14)",
            },
          },
        }}
      >
        {categoryOrders.map((co) => (
          <MenuItem
            key={co._id}
            selected={co._id === selectedCategoryOrderId}
            sx={{
              minHeight: 40,
              boxSizing: "border-box",
              borderRadius: "10px",
              padding: "8px 12px",
              color: "#4b5563",
              fontSize: 14,
              fontWeight: 500,
              "&.Mui-selected": {
                background: "#eff6ff",
                color: "#2563eb",
              },
              "&.Mui-selected:hover": { background: "#e8f1fd" },
            }}
            onClick={() => {
              updateSelectedCategoryOrderId(co._id);
              handleClose();
            }}
          >
            <span style={{ flex: 1 }}>{co.name}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
